import React, { createContext, useContext, useState, useEffect } from 'react';
import { companyAPI } from '../api';

const CompanyContext = createContext(null);

export function CompanyProvider({ children }) {
    const [company, setCompany] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const raw = localStorage.getItem('gaaf_company');
        if (raw) { try { setCompany(JSON.parse(raw)); } catch { } }
        setLoading(false);
    }, []);

    const selectCompany = async (companyId) => {
        const { data } = await companyAPI.getPublic(companyId);
        const co = data.company || data;
        localStorage.setItem('gaaf_company', JSON.stringify(co));
        setCompany(co);
        return co;
    };

    const clearCompany = () => {
        localStorage.removeItem('gaaf_company');
        setCompany(null);
    };

    return (
        <CompanyContext.Provider value={{ company, loading, selectCompany, clearCompany }}>
            {children}
        </CompanyContext.Provider>
    );
}

export const useCompany = () => useContext(CompanyContext);
